import {getModel} from './model_metadata'
import {getAssociationKey, isMultipleRelation} from './record_keys'

const defaultJoinPlanCache = new Map()
const emptyDefaultJoinPlan = {
	defaultJoinKeys: [],
	defaultJoins: [],
	defaultJoinCacheKeys: [],
	extraJoins: [],
	joinKeys: [],
}

export const buildJoinPlanMetadata = ({key, customJoins = [], seenKeys = []}) => {
	const defaultPlan = getDefaultJoinPlan({key, seenKeys})
	if (!customJoins.length) return defaultPlan

	const extraJoinKeys = customJoins.filter(joinKey => !defaultPlan.defaultJoinKeys.includes(joinKey))

	return {
		defaultJoins: defaultPlan.defaultJoins,
		defaultJoinCacheKeys: defaultPlan.defaultJoinCacheKeys,
		extraJoins: buildJoinDescriptors(key, extraJoinKeys),
		joinKeys: [...defaultPlan.defaultJoinKeys, ...extraJoinKeys],
	}
}

const getDefaultJoinPlan = ({key, seenKeys}) => {
	if (seenKeys.includes(key)) return emptyDefaultJoinPlan
	let joinPlan = defaultJoinPlanCache.get(key)
	if (joinPlan) return joinPlan

	const defaultJoinKeys = getModel(key)?.defaultJoins || []
	joinPlan = {
		defaultJoinKeys,
		defaultJoins: buildJoinDescriptors(key, defaultJoinKeys),
		defaultJoinCacheKeys: buildJoinDependencyKeys(defaultJoinKeys),
		extraJoins: [],
		joinKeys: defaultJoinKeys,
	}
	defaultJoinPlanCache.set(key, joinPlan)
	return joinPlan
}

const buildJoinDescriptors = (key, joinKeys) => {
	return joinKeys.map(joinKey => ({
		key: joinKey,
		associationKey: getAssociationKey(key, joinKey),
		isMultiple: isMultipleRelation(key, joinKey),
	}))
}

export const buildJoinDependencyKeys = joinKeys => {
	const result = []
	const addJoin = joinKey => {
		if (result.includes(joinKey)) return
		result.push(joinKey)
		const defaultJoins = getModel(joinKey)?.defaultJoins || []
		defaultJoins.forEach(addJoin)
	}

	joinKeys.forEach(addJoin)
	return result
}
